import { Publisher } from '@opentok/client';
import { getMediaStats, MediaStats } from '../../utils';

/**
 * It doesn't provide participant specific stats and returns all possible
 * data for outbound connections.
 */
export class PublisherStats {
  private lastReports: OT.PublisherRtcStatsReportArr = [];

  constructor(private readonly publisher: Publisher) {}

  async getStats(): Promise<MediaStats[] | undefined> {
    try {
      const stats: MediaStats[] = [];
      const reports = await this.publisher.getRtcStatsReport();

      for (const report of reports) {
        const lastReport = this.lastReports.find(
          (r) =>
            r.connectionId === report.connectionId &&
            r.subscriberId === report.subscriberId,
        );

        const mediaStats = getMediaStats(
          report.rtcStatsReport,
          'outbound',
          lastReport?.rtcStatsReport,
        );

        stats.push(mediaStats);
      }

      this.lastReports = reports;

      return stats;
    } catch (error) {
      if (
        error instanceof Error &&
        error.message.includes('PeerConnection not connected')
      ) {
        return undefined;
      }

      throw error;
    }
  }
}
